import { useEffect, useState } from 'react';
import { imageUrl } from './api';

// Xem ảnh toàn màn hình. Bấm ảnh để chuyển giữa "vừa màn hình" và "kích thước gốc".
export default function ImageViewer({ images, startId, onClose }) {
  const [index, setIndex] = useState(Math.max(0, images.findIndex((img) => img.id === startId)));
  const [zoomed, setZoomed] = useState(false);
  const hasMany = images.length > 1;

  const go = (step) => {
    setIndex((i) => (i + step + images.length) % images.length);
    setZoomed(false);
  };

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
      if (e.key === 'ArrowLeft' && hasMany) go(-1);
      if (e.key === 'ArrowRight' && hasMany) go(1);
    };
    window.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden'; // không cho trang phía sau cuộn
    return () => {
      window.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const img = images[index];

  return (
    <div className="viewer">
      <div className={`viewer-stage ${zoomed ? 'zoomed' : ''}`}>
        <img
          src={zoomed ? img.imageUrl : imageUrl(img.imageUrl, 2000)} // phóng to: ảnh gốc đầy đủ chi tiết
          alt=""
          onClick={() => setZoomed(!zoomed)}
          title={zoomed ? 'Bấm để thu nhỏ' : 'Bấm để xem kích thước gốc'}
        />
      </div>

      <div className="viewer-bar">
        <span>
          {hasMany && `${index + 1}/${images.length} · `}
          {zoomed ? 'Bấm ảnh để thu nhỏ' : 'Bấm ảnh để phóng to'}
        </span>
        <button onClick={onClose}>✕ Đóng</button>
      </div>

      {hasMany && (
        <>
          <button className="viewer-nav prev" onClick={() => go(-1)} aria-label="Ảnh trước">
            ‹
          </button>
          <button className="viewer-nav next" onClick={() => go(1)} aria-label="Ảnh sau">
            ›
          </button>
        </>
      )}
    </div>
  );
}
